import { useField } from 'formik'
import React, { FC, useEffect, useRef } from 'react'

import './ColorPicker.scss'

type ColorPickerData = {
  name: string
}

const ColorPicker: FC<ColorPickerData> = (props) => {
  const [field, meta, helpers] = useField(props)
  const inputRef = useRef<any>(null)

  const showPalette = () => {
    inputRef.current.click()
  }

  useEffect(() => {
    if (!field.value) {
      helpers.setValue('#000000')
    }
  }, [field.value, helpers])

  return (
    <div className='color-picker'>
      <div className='color-picker__preview' onClick={showPalette}>
        <div className='color-picker__preview__mask' style={{ background: field.value }}></div>
        <input
          {...props}
          className='color-picker__preview__input'
          {...field}
          type='color'
          ref={inputRef}
        />
        <div className='color-picker__preview__name'>{meta.value.toUpperCase()}</div>
      </div>
    </div>
  )
}

export default ColorPicker
